'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { INTERNALLY_NAVIGATING_KEY } from '@/lib/constants';
import CloseIcon from '@/public/svg/close.svg';

import styles from './BackButton.module.scss';
import { canAccessStorage } from '@/lib/helpers/is-storage-available';

interface BackButtonProps {
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = (props) => {
  const { className } = props;

  const router = useRouter();

  const [isInternallyNavigating, setIsInternallyNavigating] = useState(false);

  useEffect(() => {
    if(canAccessStorage('sessionStorage')) {
      setIsInternallyNavigating(sessionStorage.getItem(INTERNALLY_NAVIGATING_KEY) === 'true')
    }
  }, [])

  const handleBack = () => {
    // RWEB-10025 adds hashed tab navigation on Show Detail Pages, when this BackButton is clicked,
    // we want to go back to the previous page, not the previous tab.
    const navigation = window.navigation;
    const currentEntry = navigation?.currentEntry;
    if (!navigation || !currentEntry?.url) {
      router.back();
      return;
    }

    const withoutHash = (url: string) => url.split('#')[0];
    const currentUrl = withoutHash(currentEntry.url);
    // Find the most recent history entry that is not the current page (ignoring hash changes)
    const previousPageEntry = navigation
      .entries()
      .slice(0, currentEntry.index)
      .reverse()
      .find((entry) => entry.url && withoutHash(entry.url) !== currentUrl);

    if (previousPageEntry) {
      navigation.traverseTo(previousPageEntry.key);
    } else {
      router.back();
    }
  }

  let classNames = `${styles.back_button}`;

  if (className) {
    classNames += ` ${className}`;
  }

  if (isInternallyNavigating) {
    return (
      <button onClick={handleBack} aria-label="Go Back" className={classNames}>
        <CloseIcon />
      </button>
    )
  } else {
    return (
      <Link href="/" className={classNames} aria-label="Go Home">
        <CloseIcon />
      </Link>
    )
  }
}

export default BackButton;
